import { BaseService } from "../BaseService";
import { TherapistStatusHistoryBaseService } from "./TherapistStatusHistoryBaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { TherapistStatusHistoryModel } from "../../models/api/TherapistStatusHistoryModel";
import { TherapistStatusHistoryFindResultModel } from "../../models/api/TherapistStatusHistoryFindResultModel";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})

export class TherapistStatusHistoryService extends TherapistStatusHistoryBaseService {

    constructor(private h: HttpClient, private r: Router, private a: AuthService) {
        super(h, r, a);
    };

}
